import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import {
  AfterSalesActivityTimelineSkeleton,
  NoDataFound,
} from "../../../../../Components";
import { ActivityItemTimeline } from "./ActivityItemTimeline";
import { GetInquirActivity } from "../../../../../Services/AfterSalesServices/AfterSalesServices";
import { useTranslate } from "../../../../../Hooks";
import { useVerticalNav } from "../../../../../Contexts/VerticalNavContext";
import { StaticLookupsIds } from "../../../../../assets/json/StaticLookupsIds";

// Styles
import useStyles from "./style";

function ActivityTimelinePanel({ contactId }) {
  const styles = useStyles();

  const { translate } = useTranslate("AfterSalesClientProfileView");
  const { setAlertBoxContent } = useVerticalNav();

  const [isLoading, setIsLoading] = useState(false);
  const [activities, setActivities] = useState({
    result: [],
    totalCount: 0,
  });

  const fetchActivities = useCallback(async () => {
    try {
      setIsLoading(true);

      const body = {
        lookupId: StaticLookupsIds.TestAfterSales,
        contactId: contactId,
      };

      const res = await GetInquirActivity(body);

      setActivities({
        result:
          res?.result.map((item) => ({
            ...item.activity,
            activityRate: item.activityRate,
            activityRateName: item.activityRateName,
          })) || [],
        totalCount: res?.totalCount || 0,
      });
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("Something-went-wrong"),
        onClose: () => setAlertBoxContent(null),
      });
      console.error("error fetching AfterSalesClientData:", error);
    } finally {
      setIsLoading(false);
    }
  }, [contactId]);

  useEffect(() => {
    fetchActivities();
  }, [fetchActivities]);

  return (
    <Box className={styles.mainContainer}>
      {isLoading ? (
        <AfterSalesActivityTimelineSkeleton numberSkeletonCard={8} />
      ) : activities?.result.length > 0 ? (
        <Box className={styles.timelineContainer}>
          <ActivityItemTimeline timelineItems={activities?.result} />
        </Box>
      ) : (
        <NoDataFound title={translate("activities")} />
      )}
    </Box>
  );
}

export default ActivityTimelinePanel;
